module.exports = __webpack_public_path__ + "img/DnD.fb908401.png";